// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-event-template-js": () => import("./../../../src/templates/eventTemplate.js" /* webpackChunkName: "component---src-templates-event-template-js" */)
}

